export function confirmSlActivation(sl) {
    if (sl.snapshot_placements > 0) {
        return window.confirm(
            `Activate "${sl.name}"?\n\n` +
            `It will not be put back on the ${sl.snapshot_placements} placement(s) it was removed from, ` +
            `and they will be discarded.\n\n` +
            `Use Re-launch instead to put it back on them.`
        )
    }

    return window.confirm(`Activate "${sl.name}"?`)
}
